import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { KPIWidget as mainModule } from './main';
import { init as mainTheme } from './themes/main';

import { IGlobalObject } from '../../../pdc-platform/src/ts/main';

declare var require: any;
require('../sass-main/pdc-widget-kpi.sass');

export class KPIWidget extends WidgetBase {
    public static _name: string = 'KPI';
    public static group = 'Charting';
    public static moduleName: string = 'pdc-widget-kpi';
    public static icon: string = 'sound-7-1';
    public static namespace: string = 'business-intelligence';
    public static themeModule = mainTheme;

    public glob: IGlobalObject;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-kpi'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = 'widget-kpi'; //VR: WI80078
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(KPIWidget);
